module.exports = __webpack_public_path__ + "img/e05418659d6e0cb7f290669e43b60b617379ba57.b00acb4a.png";